import { SxProps, Theme } from '@mui/material';

export const modalBoxStyles: SxProps<Theme> = {
  maxHeight: 'none',
  height: 'auto',
  maxWidth: '90vw',
  margin: (theme) => theme.spacing(4, 'auto'),
  position: 'relative',
  transform: 'none',
  top: 'auto',
  left: 'auto',
};

export const headerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: (theme) => theme.spacing(2),
};

export const headerTitleContainerStyles: SxProps<Theme> = {
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  gap: (theme) => theme.spacing(1),
};

export const resultsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: (theme) => theme.spacing(3),
  marginBottom: (theme) => theme.spacing(3),
};

export const resultsTextStyles: SxProps<Theme> = {
  flexGrow: 1,
};

export const accordionStyles: SxProps<Theme> = {
  mb: 2,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 1,
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: '0 0 16px 0',
  },
};

export const accordionSummaryStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey[50],
  borderRadius: 1,
  '&.Mui-expanded': {
    borderRadius: 1,
  },
  minHeight: 72,
  '& .MuiAccordionSummary-content': {
    margin: '12px 0',
    alignItems: 'center',
  },
};

export const accordionSummaryContentStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

export const accordionSummaryInfoStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  flex: 1,
};

export const accordionSummaryActionsStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  mr: 2,
};

export const accordionDetailsStyles: SxProps<Theme> = {
  borderTop: (theme) => `1px solid ${theme.palette.divider}`,
};

export const jobStatusChipStyles: SxProps<Theme> = {
  fontWeight: 500,
  '& .MuiChip-icon': {
    fontSize: '16px',
  },
};

export const parametersDisplayStyles: SxProps<Theme> = {
  cursor: 'default',
  maxWidth: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre-wrap',
  fontFamily: 'monospace',
  fontSize: '0.75rem',
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  padding: '4px 8px',
  borderRadius: 0.5,
  border: '1px solid rgba(0, 0, 0, 0.12)',
};

export const errorAlertStyles: SxProps<Theme> = {
  padding: '2px 8px',
  fontSize: '0.75rem',
};

export const skeletonContainerStyles: SxProps<Theme> = {
  mb: 2,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
};

export const skeletonHeaderStyles: SxProps<Theme> = {
  p: 2,
  backgroundColor: 'grey.50',
  borderRadius: 1,
};

export const skeletonContentStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const skeletonTextContainerStyles: SxProps<Theme> = {
  flex: 1,
};

export const skeletonChipContainerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};

export const emptyStateStyles: SxProps<Theme> = {
  textAlign: 'center',
  py: 4,
};
